import React, {
  createContext,
  useState,
  useEffect,
  useMemo,
  useCallback,
  useContext,
  useRef,
} from 'react'

import PropTypes from 'prop-types'
import { grayDarker } from '@bufferapp/ui/style/colors'
import { ChevronDown, ChevronUp } from '@bufferapp/ui/Icon'

import {
  Wrapper,
  ButtonWrapper,
  ButtonStyled,
  ListContainer,
  ListWrapper,
  ListStyled,
  ListItem,
  SectionName,
} from './styles'

// @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 0.
const DropdownContext = createContext()

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'children' implicitly has an 'any'... Remove this comment to see the full error message
const Dropdown = ({ children }) => {
  const [opened, setOpened] = useState(false)
  const dropdownRef = useRef(null)

  useEffect(() => {
    // @ts-expect-error TS(7031) FIXME: Binding element 'target' implicitly has an 'any' t... Remove this comment to see the full error message
    const onClose = ({ target }) => {
      // @ts-expect-error TS(2339) FIXME: Property 'contains' does not exist on type 'never'... Remove this comment to see the full error message
      if (!dropdownRef.current || dropdownRef.current.contains(target)) {
        return
      }

      setOpened(false)
    }

    opened
      ? document.addEventListener('click', onClose, true)
      : document.removeEventListener('click', onClose, true)
  }, [opened])

  const context = useMemo(() => ({ opened, setOpened }), [opened])

  return (
    <DropdownContext.Provider value={context}>
      <Wrapper ref={dropdownRef}>{children}</Wrapper>
    </DropdownContext.Provider>
  )
}

Dropdown.propTypes = {}

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'children' implicitly has an 'any'... Remove this comment to see the full error message
const Button = ({ children }) => {
  // @ts-expect-error TS(2339) FIXME: Property 'opened' does not exist on type 'unknown'... Remove this comment to see the full error message
  const { opened, setOpened } = useContext(DropdownContext)

  const toggle = useCallback(() => {
    setOpened(!opened)
  }, [opened])

  return (
    // @ts-expect-error TS(2769) FIXME: No overload matches this call.
    <ButtonWrapper opened={opened} onClick={toggle}>
      <ButtonStyled role="button" aria-haspopup="true" aria-expanded={opened}>
        {children}
        {opened ? <ChevronUp /> : <ChevronDown />}
      </ButtonStyled>
    </ButtonWrapper>
  )
}

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'children' implicitly has an 'any'... Remove this comment to see the full error message
const List = ({ children }) => {
  // @ts-expect-error TS(2339) FIXME: Property 'opened' does not exist on type 'unknown'... Remove this comment to see the full error message
  const { opened } = useContext(DropdownContext)

  return opened ? (
    <ListContainer>
      <ListWrapper>
        <ListStyled>{children}</ListStyled>
      </ListWrapper>
    </ListContainer>
  ) : null
}

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'name' implicitly has an 'any' typ... Remove this comment to see the full error message
const Section = ({ name, children }) => (
  <>
    {/* @ts-expect-error TS(2769) FIXME: No overload matches this call. */}
    <SectionName size={14} weight="bold" color={grayDarker}>
      {name}
    </SectionName>
    {children}
  </>
)

Section.propTypes = {
  name: PropTypes.string.isRequired,
}

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'clickable' implicitly has an 'any... Remove this comment to see the full error message
const Item = ({ clickable, children, onClick }) => {
  // @ts-expect-error TS(2339) FIXME: Property 'setOpened' does not exist on type 'unkno... Remove this comment to see the full error message
  const { setOpened } = useContext(DropdownContext)

  // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
  const onItemClick = useCallback(() => {
    setOpened(false)
    onClick()
  })

  return (
    // @ts-expect-error TS(2769) FIXME: No overload matches this call.
    <ListItem clickable={clickable} onClick={clickable ? onItemClick : null}>
      {children}
    </ListItem>
  )
}

Item.propTypes = {
  clickable: PropTypes.bool,
}

Item.defaultProps = {
  clickable: true,
}

Dropdown.Button = Button
Dropdown.List = List
Dropdown.Section = Section
Dropdown.Item = Item

export default Dropdown
